<template>
  <div id="SearchAza">
    <div class="bordered m-1" style="min-height: 60vh">
      <div class="col-12 mb-2 row">
        <!-- <i class='fa fa-search icon mr-3 pt-2' style=' z-index: 10;'></i> -->
        <div class="col-6 input-container p-0">
          <input class="form-control" placeholder="جستــو جو .... " id="searchtable" @keyup="serachtable" />
        </div>
      </div>

      <div class="col-12 table-responsive" v-if="$store.state.renderComponentGrid" style="min-height: 40vh">
        <table v-if="loadTable" class="table-hover table-bordered w-100" id="CustomTable">
          <thead class="p-2">
            <th class="text-center p-3 text-weight-bold" v-for="(item, key) in columns" :hidden="!item.visibility" :key="key" :id="'col' + key">
              {{ item.label }}
              <a v-if="item.name == 'SarfaslCombo'" class="Pointer" style="float: left"></a>
              <a v-else @click="sortTable(item.name)" class="Pointer" style="float: left"><i class="fas fa-sort sorticon" :id="'sort' + item.name"></i></a>
            </th>
          </thead>
          <tbody>
            <tr v-for="(row, keyrow) in rowNum" :key="keyrow" :id="'row' + keyrow">
              <td v-for="(item, key) in columns" :hidden="!item.visibility" :key="key" class="text-center dropdownParent pt-1 pb-1">
                <div class="container">
                  <span v-if="item.name == 'SarfaslCombo'" class="pr-0 pl-0 mr-0 ml-0 w-100 h-100 dropdownParent">
                    <!-- {{ rows[keyrow].tblSarfaslId ? true : false }} -->
                    <ComboSanad :edit="editComputed" @ResultCombo="getSarfaslComboValue" :rownumintable="keyrow" :defaultvalue="rows[keyrow].tblSarfaslId" :action="'Sarfasl/GetCmbSarfasl'" :method="'POST'" :idinput="item.name + String(keyrow)" :keyItem="keyrow"> </ComboSanad>
                  </span>
                  <span v-else-if="item.name == 'SharhCodeSarfaslJoze' && $route.params.Status != 'View'" class="pr-0 pl-0 mr-0 ml-0 w-100 h-100">
                    <span v-if="rows[keyrow].WithJoze == 1 && [1, 2, 13, 6].includes(rows[keyrow].TblSarfaslTypeId)">
                      <span v-if="rows[keyrow].ShowJoze" class="w-100">
                        <div class="row w-100 m-0">
                          <div class="col-9 p-1">
                            <span
                              >( {{ rows[keyrow].NameFamily }} -{{ rows[keyrow].DesNoe }}
                              )
                            </span>
                          </div>
                          <div class="col-2">
                            <button :disabled="editComputed" class="btn btn-outline-warning p-1" tabindex="-1" @click.prevent="rows[keyrow].ShowJoze = false">
                              <i class="fa fa-pen"></i>
                            </button>
                          </div>
                        </div>
                      </span>
                      <span v-else class="w-100">
                        <div class="row w-100">
                          <div class="col-9 w-100 m-0">
                            <input
                              :disabled="editComputed"
                              v-mask="$session.get('UserInfo').codeShobe.trim() + '-##-######'"
                              @focusout="SearchTaahod($event, keyrow)"
                              :placeholder="$session.get('UserInfo').codeShobe.trim() + '-__-______'"
                              type="text"
                              class="CustomFormControl InputText"
                              style="direction: ltr"
                              v-model="rows[keyrow].Vcode"
                            />
                          </div>
                          <div class="col-2 w-100 p-0 m-0">
                            <button :disabled="editComputed" type="button" tabindex="-1" class="btn btn-outline-warning" @click=";(SelectedRow = keyrow), (TaahodSearch = true), (AzaSearch = false), (tblSarfaslTypeId = rows[keyrow].TblSarfaslTypeId), OpenModal(true)" dir="ltr">
                              <span class="fa fa-list" tabindex="-1"></span>
                            </button>
                          </div>
                        </div>
                      </span>
                    </span>
                    <span v-if="rows[keyrow].WithJoze == 1 && ![1, 2, 13, 6].includes(rows[keyrow].TblSarfaslTypeId)" class="w-100 m-0">
                      <span v-if="rows[keyrow].ShowJoze" class="w-100">
                        <div class="row w-100 m-0">
                          <div class="col-9 p-1">
                            <span>( {{ rows[keyrow].NameFamily }} ) </span>
                          </div>
                          <div class="col-2">
                            <button class="btn btn-outline-success p-1" tabindex="-1" @click.prevent="rows[keyrow].ShowJoze = false">
                              <i class="fa fa-pen"></i>
                            </button>
                          </div>
                        </div>
                      </span>
                      <span v-else>
                        <div class="row w-100">
                          <div class="col-9 w-100 m-0">
                            <input
                              :disabled="editComputed"
                              v-mask="$Get_FormatShomareOzv()"
                              :placeholder="$session.get('UserInfo').codeShobe.trim() + '-__-______'"
                              type="text"
                              @focusout="SearchShomareozv($event, keyrow)"
                              @keypress="$ValidNumber($event, 16)"
                              class="CustomFormControl InputText"
                              style="direction: ltr"
                              v-model="rows[keyrow].ShomareOzv"
                            />
                          </div>

                          <div class="col-2 w-100 p-0 m-0">
                            <button :disabled="editComputed" type="button" tabindex="-1" class="btn btn-outline-success" @click.prevent=";(SelectedRow = keyrow), (TaahodSearch = false), (AzaSearch = true), OpenModal(false)" dir="ltr">
                              <span class="fa fa-list" tabindex="-1" :id="'azahesab' + keyrow"></span>
                            </button>
                          </div>
                        </div>
                      </span>
                    </span>
                    <input v-if="rows[keyrow].WithJoze == 0 && rows[keyrow].TblSarfaslTypeId == null" value="" disabled tabindex="-1" type="text" class="CustomFormControl p-1 pr-2 text-right" />
                    <!-- <input disabled class="CustomFormControl p-1 pr-2 text-right" value="xxxx"> -->
                  </span>
                  <span v-else-if="item.name == 'SharhCodeSarfaslJoze' && $route.params.Status == 'View'" class="pr-0 pl-0 mr-0 ml-0 w-100 h-100">
                    <input disabled class="CustomFormControl p-1 pr-2 text-right" :hidden="!item.visibility" :name="item.name" :id="item.name + String(keyrow)" type="text" v-model="rows[keyrow].Vcode" />
                  </span>

                  <span v-else-if="item.name == 'HesabJoze'" class="m-0 w-100 h-100">
                    <!-- <combo
                      :IsDisabled="editComputed"
                      v-if="(rows[keyrow].TblSarfaslTypeId == 1 || rows[keyrow].MablaghGhestVam > 0 || rows[keyrow].MablaghSharj > 0) && rows[keyrow].tblTaahodatId != ''"
                      :Params="rows[keyrow].tblTaahodatId"
                      :GridRowNum="keyrow"
                      :ActionUrl="'b_GetRizAghsat'"
                      :Istabindex="1"
                      :IsLoad="true"
                      @sanadrizComboVlueResult="ValueResultGetRizAghsat"
                      :Op_TextDefult="'انتخاب قسط'"
                      :IsDefault="true"
                      tabindex="2"
                    ></combo> -->
                    <SearchableCombo
                      v-if="(rows[keyrow].TblSarfaslTypeId == 1 || rows[keyrow].MablaghGhestVam > 0 || rows[keyrow].MablaghSharj > 0) && rows[keyrow].tblTaahodatId != ''"
                      :edit="false"
                      :grp="11"
                      :GridRowNum="keyrow"
                      @sanadrizComboVlueResult="ValueResultGetRizAghsat"
                      :rownumintable="3"
                      :queryString="{ id: rows[keyrow].tblTaahodatId }"
                      :action="'TblCombo/b_GetRizAghsat'"
                      :method="'GET'"
                      :idinput="'Ghest' + keyrow"
                      :keyItem="'Ghest' + keyrow"
                      :disabled="false"
                    >
                    </SearchableCombo>
                  </span>
                  <span v-else-if="item.name == 'SharhSanadRiz'" class="pr-0 pl-0 mr-0 ml-0 w-100 h-100">
                    <textarea style="color: var(--sidebar-color-item) !important" :disabled="editComputed" class="CustomFormControl p-1 pr-2 text-right" :hidden="!item.visibility" :name="item.name" :id="item.name + String(keyrow)" type="text" v-model="rows[keyrow][item.name]"> </textarea>
                  </span>
                  <!-- <span v-else-if="item.name == 'SharhSanadRiz'&& $route.params.Status == 'View'" class="pr-0 pl-0 mr-0 ml-0 w-100 h-100" style="white-space: no-wrap"> -->
                  <!-- {{rows[keyrow][item.name]}}   
                                </span> -->
                  <span v-else class="tablesapn">
                    <input
                      :disabled="editComputed"
                      class="CustomFormControl p-1 pr-2 text-right"
                      :hidden="!item.visibility"
                      :name="item.name"
                      @focus="$RemoveZero($event)"
                      @focusout="
                        $AddZero($event)
                        checkforNewRow(key)
                      "
                      :id="item.name + String(keyrow)"
                      type="text"
                      v-model="rows[keyrow][item.name]"
                    />
                    <!-- <input   :disabled="editComputed" class="CustomFormControl p-1 pr-2 text-right" :hidden="!item.visibility" :name="item.name" :id="item.name + String(keyrow)" type="text" v-model="rows[keyrow][item.name]" > -->
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="HasSum">
            <tr class="Pointer" style="height: 5vh">
              <td v-for="(item, key) in columns" id="sumTable" style=" !important" :hidden="!item.visibility" :key="key" class="text-center mr-0 p-0 text-weight-bold">
                <span v-if="item.name == 'Bestan'" class="w-100 btn-outline-success my-1 h-100 h6 p-2 badge"> {{ Sumc(item.name) }}</span>
                <span v-if="item.name == 'Bedeh'" class="w-100 btn-outline-danger my-1 h-100 p-2 h6 badge border-danger border border-danger">{{ Sumc(item.name) }}</span>
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="col-12">
          <button type="button" :disabled="DefPage <= 0" class="btn btn-secondary mr-1" dir="ltr" @click="Back()">
            <span class="mr-2">صفحه قبلی</span>
            <span class="fa fa-arrow-right mt-1"></span>
          </button>
          <span class="mx-2">
            صفحه <span class="badge badge-secondary">{{ DefPage + 1 }}</span> - {{ AllPage }}
          </span>
          <button type="button" :disabled="DefPage >= AllPage - 1" class="btn btn-secondary mr-1" dir="ltr" @click="Next()">
            <span class="fa fa-arrow-left mt-1"></span>
            <span class="ml-2">صفحه بعدی</span>
          </button>
        </div>
      </div>
      <div class="row" v-if="$route.params.Status != 'Edit' && $route.params.Status != 'View'">
        <div class="col-md-9 col-12">
          <div class="col-6 col-12">
            <button title="سطر جدید F3" id="F3New" @click.prevent="Addrow" class="btn btn-sm btn-success mt-2 ml-1">
              <span class="fas fa-plus-circle"></span>
            </button>
            <button title="حدف آخرین سطر F4" @click.prevent="deleteRow" class="btn btn-sm btn-danger mt-2">
              <span class="fas fa-trash"></span>
            </button>
            <!-- <span  @click="Addrow" class="badge Pointer badge-success p-1 font-weight-normal mt-2"> سطر جدید F3</span>
            <span @click="deleteRow" class="badge Pointer badge-danger mr-2 font-weight-normal p-1 mt-2"> حدف آخرین سطر F4</span> -->
          </div>
        </div>
        <div class="col-md-3 col-12 mt-3">
          <div class="col-3 col-12">
            <button @click.prevent="SabtDaemSanad" class="btn btn-block btn-outline-success">
              <span class="mr-2">ثبت سند F9</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mt-4">
      <!-- <button class="btn btn-success" @click="Addrow"><i class="fa fa-plus"></i></button>
        <button class="btn btn-danger" @click="deleteRow"><i class="fa fa-trash"></i></button>
        <button class="btn btn-info" @click="edits">Edit</button> -->
    </div>
    <Modal v-if="$store.state.Modal" :InheritanceTheme="true" :IsFooter="false" :Size="'Md'">
      <template v-slot:body>
        <div class="container text-right">
          <search-taahod :NoRouteForm="'frmSearchTaahod'" v-if="TaahodSearch" @Taahod="GetTaahodSearched" :tblSarfaslTypeId="tblSarfaslTypeId"> </search-taahod>
          <search-aza v-if="AzaSearch" @OzvSelected="GetAzaSearched"></search-aza>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import SearchTaahod from '@/pages/BnpCash/MnuOmorMali/SmnuHesabdari/SearchTaahod.vue'
import SearchAza from '@/components/BnpCash/SearchAza.vue'
import ComboSanad from '@/components/BnpCash/SanadComponents/ComboSanad.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Modal from '@/pages/Modal/Modal.vue'

export default {
  components: { ComboSanad, SearchTaahod, SearchableCombo, SearchAza, Modal },
  data() {
    return {
      loadTable: false,
      AllPage: 0,
      DefPage: 0,
      sabtnashode: true,
      tblSarfaslTypeId: '',
      totalBedeh: 0,
      totalBestan: 0,
      columns: [],
      visibilColumns: [],
      rowNum: 0,
      HasSum: true,
      Sum: [],
      AzaSearch: false,
      TaahodSearch: false,
      rows: [],
      SumRow: {},
      editable: false,
      SumColumn: ['Mande', 'GhabelBardasht', 'DesnNoe'],
      NumberFields: ['Mande', 'Mablagh', 'GhabelBardasht', 'mablagh', 'Bedeh', 'Bestan', 'MablaghSharj'],
      SelectedRow: 0,
      DataAxios_DataAdd: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'SanadRizNew/b_AddSanadRizMovaghat',
        Token: this.$session.get('Token'),
      },
      DattAxios_DataSabtDaem: { ArryfildValue: {} },
      FinalDataAxios_DataSabtDaem: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'SanadRizNew/SabtDaemiSanad',
        Token: this.$session.get('Token'),
      },
    }
  },
  mounted() {
    this.rowNum = this.rows.length
    this.loadTable = true
    if (this.$route.params.Status != 'Edit' && this.$route.params.Status != 'View') {
      document.getElementById('F3New').click()
    }
    // this.$FormatMablaghGrid(this.rows);
  },
  created() {
    this.rows = []
    this.editable = this.edit == true ? true : false
    // this.rows = this.rowsProp;
    this.rows.forEach((element) => {
      element.ShowJoze = false
    })
    if (!(this.$route.params.Status == 'View' || this.$route.params.Status == 'Edit')) {
      this.$emit('sabtnashode', true)
    } else {
      this.AllPage = Math.ceil(this.rowsProp.length / 10)
      this.rows = this.rowsProp.slice(0, this.DefPage * 10 + 10)
      this.rowNum = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    }
    this.columns = this.cols
    if (this.rowsProp.length < 10) {
      this.rows = this.rowsProp
    } else {
      this.rows.push(JSON.parse(JSON.stringify(this.$store.state[this.$route.name].EmptyRow[0])))
    }

    if (this.sabteDaemiSanad) {
      // alert('سند موقت ثبت نشده')
    }
    // console.log(this.rows);
    window.addEventListener('keydown', this.keyHandler)
  },
  methods: {
    OpenModal(isTaahodat) {
      this.$store.state.Modal = true
      TaahodSearch = isTaahodat
      AzaSearch = !isTaahodat
    },
    Next() {
      this.DefPage++
      this.rowNum = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
      this.rows = this.rowsProp.slice(this.DefPage * 10, this.DefPage * 10 + 10)
      this.$store.state.renderComponentGrid = false
      this.$nextTick(() => {
        this.$store.state.renderComponentGrid = true
      })
    },
    Back() {
      this.DefPage--
      this.rowNum = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
      this.rows = this.rowsProp.slice(this.DefPage * 10, this.DefPage * 10 + 10)
    },
    SabtDaemSanad() {
      if (this.totalBestan != this.totalBedeh) {
        this.$mySweetDefaultTost('سند تراز نیست', '', 'warning', 1500)
      } else {
        var ErrorInData = false
        this.rows.forEach((row) => {
          if (row.WithJoze == true) {
            if ((row.Vcode == '' && row.ShomareOzv == '') || (row.Vcode == null && row.ShomareOzv == null)) {
              ErrorInData = true
            }
          }
        })
        if (ErrorInData) {
          this.$mySweetDefaultTost('حساب جزء انتخاب نشده است.', '', 'warning', 1500)
        } else this.SabtAddAllSanadRiz(true)
      }
    },
    RemoveRow(id) {
      document.getElementById('row' + id).remove()
    },
    edits() {
      this.editable = this.editable ? false : true
      this.Grid3ragham()
    },
    focus(key) {
      document.getElementById('row' + key).focus = true
    },
    RowsToShwo(x) {
      this.ReturnRow = []
      var SelectedRow
      if (this.rows[x]) {
        SelectedRow = this.rows[x]
      } else {
        SelectedRow = this.$store.state[this.$route.name].EmptyRow
      }
      this.visibilColumns.forEach((element) => {
        this.ReturnRow.push(SelectedRow[element.name])
      })
      return this.ReturnRow
    },
    Addrow() {
      var row
      // if(this.rows.length===0){
      row = JSON.parse(JSON.stringify(this.$store.state[this.$route.name].EmptyRow[0]))
      row.tblSanadId = this.$store.state.SanadRizNew.DataAdd.tblSanadId
      this.rows.push(row)
      var id = 'SarfaslCombo' + this.rowNum.toString()
      document.getElementById(id)
      this.rowNum++
      this.$nextTick(() => {
        document.getElementById(id).focus()
      })
      this.$nextTick(() => {
        document.getElementById(id).click()
      })

      // }
      // else{
      // row = JSON.parse(JSON.stringify(this.$store.state[this.$route.name].EmptyRow[0]))
      // row.tblSanadId=this.$store.state.SanadRizNew.DataAdd.tblSanadId
      // this.rows.push(row)
      // this.rowNum ++
      //     // this.SabtAddRowSanadRiz(this.rows[this.rows.length-2]);
      // }
    },
    SabtAddRowSanadRiz(rowAdd) {
      this.DataAxios_DataAdd.ArryfildValue.tblSanadId = this.$store.state.SanadRizNew.DataAdd.tblSanadId
      this.DataAxios_DataAdd.ArryfildValue.SharhSanadRiz = rowAdd.SharhSanadRiz
      this.DataAxios_DataAdd.ArryfildValue.tblTaahodatId = rowAdd.tblTaahodatId
      this.DataAxios_DataAdd.ArryfildValue.Bedeh = rowAdd.Bedeh
      this.DataAxios_DataAdd.ArryfildValue.FishNoRahgiri = rowAdd.FishNoRahgiri
      this.DataAxios_DataAdd.ArryfildValue.Bestan = rowAdd.Bestan
      this.DataAxios_DataAdd.ArryfildValue.tblAzaIdTafsili = rowAdd.tblAzaIdTafsili
      this.DataAxios_DataAdd.ArryfildValue.tblTaahodatRizId = rowAdd.tblTaahodatRizId
      this.DataAxios_DataAdd.ArryfildValue.Varizkonande = rowAdd.Varizkonande
      this.DataAxios_DataAdd.ArryfildValue.tblCheckVaDaftarcheMoshtariRizId = rowAdd.tblCheckVaDaftarcheMoshtariRizId
      this.DataAxios_DataAdd.ArryfildValue.tblChkSareHesabId = rowAdd.tblChkSareHesabId
      this.DataAxios_DataAdd.ArryfildValue.tblTaahodatIdKarmozd = rowAdd.tblTaahodatIdKarmozd
      this.DataAxios_DataAdd.ArryfildValue.TarixCheckBanki = rowAdd.TarixCheckBanki
      this.DataAxios_DataAdd.ArryfildValue.tblTaahodatIdMortabet = rowAdd.tblTaahodatIdMortabet
      this.DataAxios_DataAdd.ArryfildValue.tblSarfaslId = rowAdd.tblSarfaslId
      this.DataAxios_DataAdd.ArryfildValue.tblCheckBankiRizId = rowAdd.tblCheckBankiRizId
      this.DataAxios_DataAdd.ArryfildValue.tblComboIdNahvePardaxt29 = rowAdd.tblComboIdNahvePardaxt29
      this.DataAxios_DataAdd.ArryfildValue.DesSanadRiz = rowAdd.DesSanadRiz
      this.DataAxios_DataAdd.ArryfildValue.tblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId

      // console.log(this.DataAxios_DataAdd.ArryfildValue);
      this.$PostData(this.DataAxios_DataAdd).then((result) => {})
    },
    SabtAddAllSanadRiz(val) {
      this.$mySweetDefaultTost('', 'در حال ثبت سند', 'info')
      var rowsToSend = []
      var sanadid = this.$store.state.SanadRizNew.DataAdd.tblSanadId
      var tblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
      this.rows.forEach(function (element) {
        var row = {}
        row.tblSanadId = sanadid
        row.SharhSanadRiz = element.SharhSanadRiz
        row.tblTaahodatId = element.tblTaahodatId
        row.Bedeh = element.Bedeh
        row.FishNoRahgiri = element.FishNoRahgiri
        row.Bestan = element.Bestan
        row.tblAzaIdTafsili = element.tblAzaIdTafsili
        row.tblTaahodatRizId = element.tblTaahodatRizId
        row.Varizkonande = element.Varizkonande
        row.tblCheckVaDaftarcheMoshtariRizId = element.tblCheckVaDaftarcheMoshtariRizId
        row.tblChkSareHesabId = element.tblChkSareHesabId
        row.tblTaahodatIdKarmozd = element.tblTaahodatIdKarmozd
        row.TarixCheckBanki = element.TarixCheckBanki
        row.tblTaahodatIdMortabet = element.tblTaahodatIdMortabet
        row.tblSarfaslId = element.tblSarfaslId
        row.tblCheckBankiRizId = element.tblCheckBankiRizId
        row.tblComboIdNahvePardaxt29 = element.tblComboIdNahvePardaxt29
        row.DesSanadRiz = element.DesSanadRiz
        row.tblUserGrpIdInsert = tblUserGrpIdInsert
        row.IsUserDeleted = false
        row.IsTaeid = false
        rowsToSend.push(row)
      })
      this.DataAxios_DataAdd.ArryfildValue = rowsToSend
      this.$PostData(this.DataAxios_DataAdd)
        .then((result) => {})
        .finally(() => {
          if (val) {
            this.DattAxios_DataSabtDaem.ArryfildValue.TarixSanad = this.$store.state.SanadRizNew.Data[0].TarixSanad
            this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadMovaghatId = this.$store.state.SanadRizNew.DataAdd.tblSanadId
            this.DattAxios_DataSabtDaem.ArryfildValue.b_ShomareSanad = this.$store.state.SanadRizNew.Data[0].ShomareSanad
            this.DattAxios_DataSabtDaem.ArryfildValue.b_ShobeId = this.$session.get('UserInfo').tblShobeId
            this.DattAxios_DataSabtDaem.ArryfildValue.b_UserId = this.$session.get('UserInfo').tblUserId
            this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadDate = this.$store.state.SanadRizNew.Data[0].TarixSanad
            this.DattAxios_DataSabtDaem.ArryfildValue.b_DeleteMovaghat = true
            this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadId = ''
            this.DattAxios_DataSabtDaem.ArryfildValue.b_Checking = false
            this.DattAxios_DataSabtDaem.ArryfildValue.b_DoreId = this.DattAxios_DataSabtDaem.ArryfildValue.b_DoreId = this.$session.get('DoreMaliData')[this.$session.get('DoreMaliData').length - 1].Id
            this.DattAxios_DataSabtDaem.ArryfildValue.b_UserGrpId = this.$session.get('UserInfo').tblUserGrpId
            let b_SabtSandDaem = {
              ...this.DattAxios_DataSabtDaem.ArryfildValue,
              ...this.$store.state.b_SabtSandDaem[0],
            }
            this.FinalDataAxios_DataSabtDaem.ArryfildValue = b_SabtSandDaem
            this.$PostData(this.FinalDataAxios_DataSabtDaem).then((result) => {
              if (result.length > 0) {
                var msg = 'سند با شماره ' + result[0].b_ShomareSanad + ' با موفقیت ثبت شد'
                var icon = 'success'
                var header = ''
                if (result[0].b_ShomareSanad == -1) {
                  msg = result[0].b_ErrorMsg
                  header = 'خطا!'
                  icon = 'warning'
                  var deletedata = {
                    ArryfildValue: {
                      id: this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadMovaghatId,
                    },
                    Action: 'SanadRizNew/b_DeleteSanadMovaghat',
                    Method: 'Delete',
                    Token: this.$session.get('Token'),
                  }
                  var sweetDelete = ['اعلان', 'سند موقت حذف شد.', 'info', '2000']
                  this.$DeleteDataMostaghim(deletedata, sweetDelete, null)
                }
                this.$mySweetDefaultTost(header, msg, icon, 2000)
                if (result[0].b_ShomareSanad != -1) this.$router.push('SearchSanad')
              } else {
                this.$mySweetDefaultTost('', 'اس پی ثبت سند وجود ندارد و یا مشکلی در آن بوجودآمده است!', 'warning', 1000)
              }
            })
            this.sabtnashode = false
            this.$emit('sabtnashode', false)
          }
        })
    },
    sortTable(name) {
      var icons = document.getElementsByClassName('sorticon')
      icons.forEach((element) => {
        element.classList.remove('fa-angle-up')
        element.classList.remove('fal')
        element.classList.remove('fa-angle-down')
        element.classList.add('fa-sort')
        element.classList.add('fa')
      })
      document.getElementById('sort' + name).classList.remove('fa')
      document.getElementById('sort' + name).classList.remove('fa-sort')

      var table, rows, switching, i, x, y, shouldSwitch
      table = document.getElementById('CustomTable')
      var column = table.querySelectorAll('[name=' + name + ']')
      var sorted = false
      for (let index = 0; index < column.length - 1; index++) {
        var first = column[index].value.replace(/,/g, '')
        if (!isNaN(first)) {
          first = Number(first)
        }
        var second = column[index + 1].value.replace(/,/g, '')
        if (!isNaN(second)) {
          second = Number(second)
        }
        if (first > second) {
          sorted = false
          break
        }
        sorted = true
      }

      if (sorted) {
        document.getElementById('sort' + name).classList.add('fal')
        document.getElementById('sort' + name).classList.add('fa-angle-up')

        switching = true
        while (switching) {
          switching = false
          rows = table.rows
          for (i = 0; i < rows.length - 1; i++) {
            shouldSwitch = false
            x = rows[i].querySelectorAll('[name=' + name + ']')[0].value.replace(/,/g, '')
            if (rows[i + 1]) {
              if (rows[i + 1].querySelectorAll('[name=' + name + ']')[0]) {
                y = rows[i + 1].querySelectorAll('[name=' + name + ']')[0].value.replace(/,/g, '')
                if (!isNaN(x)) x = Number(x)
                if (!isNaN(y)) y = Number(y)

                if (x < y) {
                  shouldSwitch = true
                  break
                }
              } else {
                break
              }
            }
          }
          if (shouldSwitch) {
            rows[i].parentNode.insertBefore(rows[i + 1], rows[i])
            switching = true
          }
        }
      } else {
        document.getElementById('sort' + name).classList.add('fal')
        document.getElementById('sort' + name).classList.add('fa-angle-down')
        switching = true
        while (switching) {
          switching = false
          rows = table.rows
          for (i = 0; i < rows.length - 1; i++) {
            shouldSwitch = false
            alert
            if (rows[i].querySelectorAll('[name=' + name + ']')[0].nodeName == 'INPUT' || rows[i].querySelectorAll('[name=' + name + ']')[0].nodeName == 'TEXTAREA') {
              x = rows[i].querySelectorAll('[name=' + name + ']')[0].value.replace(/,/g, '')
              if (rows[i + 1].querySelectorAll('[name=' + name + ']')[0]) {
                y = rows[i + 1].querySelectorAll('[name=' + name + ']')[0].value.replace(/,/g, '')
                if (!isNaN(x)) x = Number(x)
                if (!isNaN(y)) y = Number(y)
                if (x > y) {
                  shouldSwitch = true
                  break
                }
              } else {
                break
              }
            }
          }
          if (shouldSwitch) {
            rows[i].parentNode.insertBefore(rows[i + 1], rows[i])
            switching = true
          }
        }
      }
    },
    Grid3ragham() {
      this.NumberFields.forEach((field) => {
        for (let index = 0; index <= this.rowNum; index++) {
          var idselector = field + index
          if (document.getElementById(idselector)) {
            document.getElementById(idselector).classList.add('3ragham')
          }
        }
      })
    },
    CheckKey(e) {
      var arrays = e.target.classList
      arrays.forEach((element) => {
        if (element == '3ragham') {
          this.$ValidNumber(e, 16)
          this.$PutCommatoInput()
        }
      })
      // if (e.target.classList.includes("3ragham")) {
      //     alert(" 3 -- raghami    ")
      // }
    },
    serachtable() {
      var table = document.getElementById('CustomTable')
      var search = document.getElementById('searchtable').value
      var trow = table.getElementsByTagName('tr')
      for (let index = 0; index < trow.length; index++) {
        const element = trow[index]
        if (element.Id != 'sumTable') {
          var td = element.getElementsByTagName('td')
          var cellValues = []
          for (let i = 0; i < td.length; i++) {
            var display = false
            const cell = td[i]
            if (cell.children[0]) {
              cellValues.push(cell.children.closest.value.replace(/,/g, ''))
              cellValues.forEach((valuetable) => {
                if (valuetable.indexOf(search) != -1) {
                  element.style.display = ''
                  display = true
                }
              })
              if (display) {
                element.style.display = ''
              } else {
                element.style.display = 'none'
              }
            }
          }
        }
      }
    },
    getSarfaslComboValue(val) {
      // console.log(this.rows, val.key,val.idrow );
      val.idrow = String(val.idrow).replace(val.key, '')
      // console.log("Defaulllllllllllllllllllt",this.rows, val);
      this.rows[val.key].SharhSarfaslKol = val.name
      this.rows[val.key].tblSarfaslId = val.id
      this.rows[val.key].WithJoze = val.WithJoze
      this.rows[val.key].TblSarfaslTypeId = val.TblSarfaslTypeId
      this.rows[val.key].tblAzaIdTafsilid = ''
      this.rows[val.key].NameFamily = ''
      this.rows[val.key].ShomareOzv = ''
      this.rows[val.key].tblTaahodatId = ''
      this.rows[val.key].DesNoe = ''
      this.rows[val.key].Vcode = ''
      this.rows[val.key].ShowJoze = false
    },
    GetAzaSearched(AzaInfo) {
      // console.log(AzaInfo);

      this.rows[this.SelectedRow].tblAzaIdTafsili = AzaInfo.Id
      this.rows[this.SelectedRow].NameFamily = AzaInfo.FamilyName
      this.rows[this.SelectedRow].ShomareOzv = AzaInfo.ShomareOzv
      this.rows[this.SelectedRow].ShowJoze = true

      // console.log(this.rows);
    },
    GetTaahodSearched(taahod) {
      this.rows[this.SelectedRow].tblTaahodatId = taahod.Id
      this.rows[this.SelectedRow].Vcode = taahod.Vcode
      this.rows[this.SelectedRow].NameFamily = taahod.OzvFamilyName
      this.rows[this.SelectedRow].ShomareOzv = taahod.ShomareOzv
      this.rows[this.SelectedRow].DesNoe = taahod.DesNoe

      this.rows[this.SelectedRow].TblSarfaslTypeId = taahod.TblSarfaslTypeId
      this.rows[this.SelectedRow].MablaghSharj = taahod.MablaghSharj
      this.rows[this.SelectedRow].MablaghGhestVam = taahod.MablaghGhestVam
      this.rows[this.SelectedRow].ShowJoze = true
    },
    SearchShomareozv(e, keyrow) {
      e.target.value = e.target.value.replace(this.$session.get('UserInfo').codeShobe.trim() + '-', '')
      e.target.value = e.target.value.padStart(6, 0)
      e.target.value = this.$session.get('UserInfo').codeShobe.trim() + '-' + e.target.value
      var DataAxiosSerch = {
        ArryfildValue: {
          ShomareOzv: e.target.value,
          OzvFamilyName: '',
          Mobile: '',
          CodeMeli: '',
          Shenasname: '',
          OzvFamily: '',
          OzvName: '',
          Parvandeh: '',
        },
      }
      DataAxiosSerch.ArryfildValue.TblGrpId = this.$session.get('UserInfo').tblGrpId
      DataAxiosSerch.ArryfildValue.tblShobeId = this.$session.get('UserInfo').tblShobeId
      DataAxiosSerch.Action = 'vorodi'
      DataAxiosSerch.Method = 'post'
      this.$PostData(DataAxiosSerch).then((data) => {
        if (data.length > 0) {
          this.rows[keyrow].tblAzaIdTafsilid = data[0].Id
          this.rows[keyrow].NameFamily = data[0].FamilyName
          this.rows[keyrow].ShomareOzv = data[0].ShomareOzv
          this.rows[keyrow].ShowJoze = true
          // console.log("selected");
        } else {
          this.rows[keyrow].tblAzaIdTafsilid = ''
          this.rows[keyrow].NameFamily = ''
          this.rows[keyrow].ShomareOzv = ''
          this.rows[keyrow].ShowJoze = false
          this.$mySweetDefaultTost('عدم وجود اطلاعات', 'اطلاعاتی وجود ندارد ', 'info', 3000)
        }
      })
    },
    SearchTaahod(e, keyrow) {
      var vcode = this.$session.get('b_SetVCodeMask').trim().substring(7).replaceAll('0', '#')
      e.target.value = e.target.value.replace(this.$session.get('UserInfo').codeShobe.trim() + '-', '')
      var CodeNoe = e.target.value.substring(0, 3)
      e.target.value = e.target.value.replace(e.target.value.substring(0, 3), '')
      e.target.value = e.target.value.padStart(vcode.length, 0)
      e.target.value = this.$session.get('UserInfo').codeShobe.trim() + '-' + CodeNoe + e.target.value
      var DataAxiosSerch = {
        ArryfildValue: {
          Vcode: e.target.value,
          OzvName: '',
          OzvFamily: '',
          CodeMeli: '',
          OzvFamilyName: '',
          Shenasname: '',
          ShomareOzv: '',
        },
      }
      DataAxiosSerch.ArryfildValue.Id = this.$session.get('UserInfo').tblGrpId
      // DataAxiosSerch.ArryfildValue.tblShobeId=this.$session.get('UserInfo').tblShobeId;
      DataAxiosSerch.Action = 'SearchTaahod/b_GetDataTaahod'
      DataAxiosSerch.Method = 'post'
      this.$PostData(DataAxiosSerch).then((data) => {
        if (data.Id) {
          this.rows[keyrow].tblTaahodatId = data.Id
          this.rows[keyrow].NameFamily = data.OzvFamilyName
          this.rows[keyrow].ShomareOzv = data.ShomareOzv
          this.rows[keyrow].DesNoe = data.DesNoe
          this.rows[keyrow].TblSarfaslTypeId = data.TblSarfaslTypeId
          this.rows[keyrow].MablaghSharj = data.MablaghSharj
          this.rows[keyrow].MablaghGhestVam = data.MablaghGhestVam
          this.rows[keyrow].ShowJoze = true
        } else {
          this.rows[keyrow].tblTaahodatId = ''
          this.rows[keyrow].NameFamily = ''
          this.rows[keyrow].ShomareOzv = ''
          this.rows[keyrow].DesNoe = ''
          this.rows[keyrow].Vcode = ''
          this.rows[keyrow].ShowJoze = false
          this.$mySweetDefaultTost('عدم وجود اطلاعات', 'اطلاعاتی وجود ندارد ', 'info', 3000)
        }
      })
    },
    deleteRow() {
      this.rows.pop()
      this.rowNum = this.rows.length
    },
    keyHandler(e) {
      if (e.which == 114) {
        this.Addrow()
      }
      if (e.which == 115) {
        this.deleteRow()
      }
    },
    Sumc(Itemname) {
      var sum = 0
      for (let index = 0; index < this.rowsProp.length; index++) {
        const element = this.rowsProp[index]
        if (element[Itemname]) {
          var ToNumber = element[Itemname].toString().replace(/,/g, '')
        } else {
          ToNumber = 0
        }
        sum = parseInt(sum.toString().replace(/,/g, '')) + parseInt(ToNumber)
        sum = this.$Comma3ragham(sum)
      }
      if (Itemname == 'Bedeh') {
        this.totalBedeh = sum
      }
      if (Itemname == 'Bestan') {
        this.totalBestan = sum
      }
      return sum
    },
    testShowJoze(keyrow) {
      this.rows[keyrow].ShowJoze = false
    },
    ValueResultGetRizAghsat(data) {
      try {
        this.rows[data[1]].tblTaahodatRizId = data[0].id
      } catch (error) {}
    },
    checkforNewRow(colId) {
      if (colId + 1 == this.columns.length) {
        this.Addrow()
      }
    },
  },
  computed: {
    ColumnsToShow() {
      this.columns.forEach((element) => {
        if (element.visibility == true) {
          this.visibilColumns.push(element)
        }
      })
      return this.visibilColumns
    },
    editComputed() {
      return this.$route.params.Status == 'View' ? true : false
    },
  },
  updated() {
    this.Grid3ragham()
    this.$PutCommatoInput()
    document.addEventListener('keypress', this.CheckKey)
  },
  props: ['cols', 'rowsProp', 'edit', 'sabteDaemiSanad'],
}
</script>

<style scoped>
.CustomFormControl {
  border: 1px;
  background: transparent;
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}
.tablesapn {
  background: transparent;
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}
.CustomFormControl:focus {
  outline: none !important;
  border: 1px solid #3072ff;
  box-shadow: 0 0 10px #71b8ce;
  width: 100% !important;
  background: none !important;
}
tr:focus {
  background: wheat;
}
td {
  min-height: 5vh;
  padding: 0 !important;
  max-width: 100%;
  white-space: nowrap;
}

.bg-sabz {
  background: rgb(227, 247, 208);
}
.bg-sabz:hover {
  background: rgb(64, 123, 6);
  color: rgb(235, 248, 223);
}
</style>
<style>
#SearchAza #Modal-Success .modal-dialog {
  max-width: 90vw !important;
}
#SearchAza #Modal-Info .modal-dialog {
  max-width: 60vw !important;
}
</style>
<style>
.btn-outline-orange {
  border: 1px solid #e68b03 !important;
  /* border: 1px solid #aa8406 !important; */
  color: #e68b03;
}

.btn-outline-orange:hover {
  background: #e68b03 !important;
  color: #fff;
}
.btn-outline-success {
  border: 1px solid #5ea31e !important;
  color: #67b221;
}

.btn-outline-success:hover {
  background: #5ea31e !important;
  color: #fff;
}
</style>
